function withAbsoluteContainer(
	component: React.ReactNode,
	position: 'left' | 'right'
) {
	return (
		<div
			style={{
				position: 'absolute',
				...(position === 'left' ? { left: 10 } : { right: 30 }),
			}}
		>
			{component}
		</div>
	);
}

export { withAbsoluteContainer };
